import { MenuItem } from '@mui/material'
import { SxProps, Theme } from '@mui/system'
import React, { FC } from 'react'
import Input, { BaseInputProps } from '../Input/Input'

export type SelectProps = {
  options?: { [key: string]: string | number }
  allowEmpty?: boolean
  sx?: SxProps<Theme>
} & BaseInputProps

export const Select: FC<SelectProps> = (props) => {
  const {
    id,
    value,
    required,
    name,
    label,
    defaultValue,
    InputProps,
    inputProps,
    InputLabelProps,
    helperText,
    onChange,
    autoComplete,
    error,
    children,
    allowEmpty = true,
    options,
    disabled,
    variant,
    margin,
    sx,
    SelectProps,
  } = props

  return (
    <Input
      select
      id={id}
      value={value}
      required={required}
      name={name}
      label={label}
      InputProps={InputProps}
      inputProps={inputProps}
      defaultValue={defaultValue}
      disabled={disabled}
      error={error}
      margin={margin}
      helperText={helperText}
      autoComplete={autoComplete}
      InputLabelProps={InputLabelProps}
      onChange={onChange}
      variant={variant}
      sx={sx}
      SelectProps={SelectProps}
    >
      {allowEmpty && <MenuItem value=""></MenuItem>}
      {children}
      {options &&
        Object.entries(options).map(([value, label]) => {
          return (
            <MenuItem key={value} value={value}>
              {label as string}
            </MenuItem>
          )
        })}
    </Input>
  )
}

export default Select
